import { useRadioGroup } from "@p-ban/common/src/components/form/radio/RadioGroup"
import VisuallyHidden from "@p-ban/common/src/components/layout/VisuallyHidden"
import useFocusVisible from "@p-ban/common/src/hooks/useFocusVisible"
import useHover from "@p-ban/common/src/hooks/useHover"

import InputBox from "./InputBox"

type Props = {
  prefixImageSrc?: string
  prefixNode?: React.ReactNode
  suffixImageSrc?: string
  value?: string
} & JSX.IntrinsicElements["input"]

const Radio = ({ children, prefixNode, prefixImageSrc, suffixImageSrc, value, ...props }: Props) => {
  const { name, selectedValue, onChange, disabled = false, shouldRender = () => true } = useRadioGroup()

  const checked = props.checked === undefined ? selectedValue === value : props.checked

  const { isHovered, hoverProps } = useHover()
  const { isFocusVisible, focusVisibleProps } = useFocusVisible()

  if (!shouldRender(value)) {
    return null
  }

  return (
    <label {...hoverProps}>
      <VisuallyHidden>
        <input
          name={name}
          onChange={onChange}
          checked={checked}
          disabled={disabled}
          value={value}
          {...props}
          {...focusVisibleProps}
          type="radio"
        />
      </VisuallyHidden>
      <InputBox
        checked={checked}
        disabled={disabled}
        isHovered={isHovered}
        isFocusVisible={isFocusVisible}
        prefixNode={prefixNode}
        prefixImageSrc={prefixImageSrc}
        suffixImageSrc={suffixImageSrc}
      >
        {children}
      </InputBox>
    </label>
  )
}

export default Radio
